import {Button, Flex} from 'antd';
import React from 'react';

import {ReactComponent as PricingQuestionImage} from '../../assets/PricingQuestionImage.svg';

const ContactTeam: React.FC = () => {
  return (
    <Flex vertical={false} className="questionMainContainer">
      <PricingQuestionImage />
      <Flex vertical gap={10}>
        <div className="haveAQuestionText">Have Questions About Pricing?</div>
        <div className="hereToHelp">We&apos;re here to help.</div>
        <div className="contactTeamDescription">
          Whether you&apos;re unsure which plan fits best or need a custom
          quote, our team is ready to guide you. Reach out for personalized
          support and detailed pricing information.
        </div>
      </Flex>
      <Button
        className="capsuleButton contactTeam"
        type="primary"
        onClick={() => {
          window.open(
            'https://calendly.com/discovery-bharatcarbon/30mins',
            '_blank',
            'noopener,noreferrer'
          );
        }}
      >
        Contact Our Team
      </Button>
    </Flex>
  );
};

export default ContactTeam;
